import {Axios} from "axios";

export interface StatisticsOverviewDto {
    generatedAt: string;
    openFormSessionsCount: number | null;
    totalFormSessionsCount: number | null;
    sentSubmissionsCount: number | null;
    publishedFormsCount: number | null;
}

export class StatisticsApiClient {

    constructor(private readonly axios: Axios) {
    }

    getOverview(): Promise<StatisticsOverviewDto> {
        return this.axios.get<StatisticsOverviewDto>("/statistics/overview")
            .then((response) => response.data);
    }
}
